<template>
  <div>
    <headNav></headNav>
    <div  style="height: 50px;"></div>
    <div>
      <img src="../assets/gsjj.png" class="img-responsive" />
    </div>



    <div class="container" style="margin-top: 24px;">
      <div class="row">
        <div class="col-md-3 visible-lg-block visible-md-block">

          <div
            style="padding: 12px 20px;background-color: rgba(0,0,0,.03);border: 1px solid rgba(0,0,0,.125); border-bottom: 0px;border-radius: 5px;">
            <img src="../assets/publicHead.png" class="img-responsive" />
          </div>
          <div style="width: 100%;" class="btn-group-vertical " role="group">
           <router-link to="/dszzc"><button type="button" class="btn btn-default btn-block">董事长致辞</button></router-link>
           <button type="button" class="btn btn-primary btn-block">公司简介</button>
           <router-link to="/wdjf"><button type="button" class="btn btn-default btn-block">威盾技防</button></router-link>
           <router-link to="/fwfw"> <button type="button" class="btn btn-default btn-block">服务范围</button></router-link>
           <router-link to="/xmzs"><button type="button" class="btn btn-default btn-block">项目展示</button></router-link>
           <router-link to="/wdtb"><button type="button" class="btn btn-default btn-block">威盾特保</button></router-link>
           <router-link to="/xwdt"><button type="button" class="btn btn-default btn-block">新闻动态</button></router-link>
           <router-link to="/bzzl"><button type="button" class="btn btn-default btn-block">报纸专栏</button></router-link>
           <router-link to="/hyxw"><button type="button" class="btn btn-default btn-block">行业新闻</button></router-link>
          </div>
          <div
            style="padding: 12px 20px;background-color: rgba(0,0,0,.03);border: 1px solid rgba(0,0,0,.125); border-bottom: 0px;border-radius: 5px;">
            <img src="../assets/hezuo.png" class="img-responsive" />
          </div>

        </div>
        <div class="col-md-9 text-left">
          <h2 style="font-weight: bold;margin-top: 0px;">公司简介</h2>
          <span>威盾官网 2021-11-16</span>
          <div style="text-indent: 2em;margin-top: 10px;">
          <img style="float: right;margin-left: 10px;" class="img-responsive" src="../assets/gsjj_pic.png">
          <span style="font-size: 16px;">
            河南威盾保安服务有限公司 成立于2010年12月14日，是省公安局豫公通【2010】291号文件批准成立，工商行政管理局登记注册的 一家专业保安公司。 组织机构设有：办公室、财务部、业务部、管理部、人事部、培训部，并拥有两个面积400平米的保安训练基地。公司具有严密的管理制度，拥有一支政治合格、纪律严明、训练有素、忠于职守的专业化的保安队伍。管理部门由各部队专业干部组成。保安均通过政审合格并且经医院证明身体健康的保安方可送往基地进行军训、学完培训教程。所有人员必须通过考试合格、取得上岗证书持证上岗。公司目前在册员工8000余人，向范围内的机关团体，院校，金融，饭店等事业企业等单位提供门卫、守护、巡逻、重要物资押运等有偿安全防范服务。 董事长韦存山是原河南省保安协会副主任，从事保安行业至今18年整，有着丰富的管理经验。公司坚持 客户第一，信誉至上 的企业宗旨。 坚持五统一、一独立、（统一财务、统一工作标准、统一考核、统一培训、统一装备）自主经营、独立核算为客户提供专业的保安服务。在日趋激烈的市场竞争中，为维护客户的利益，我们为每一位客户 量身定做 一套安全防范计划，并坚持按照计划严格执行。赢得了社会各界客户的广泛赞誉。对保安服务提出了更高、更严的标准和要求，河南威盾保安服务有限公司一贯致力于保安队伍政治、业务、军事、服务素质的全面建设，配合公安机关为维护郑州的治安秩序、加强各单位内部的安全防范、打击违法犯罪、保护人民群众和客户的合法权益做出积极的贡献。 为人民的安全，河南威盾保安服务有限公司全体员工继续坚持努力！
            经营范围 包括门卫、巡逻、守护、随身护卫、安全检查、安全技术防范、安全风险评估、区域秩序维护；安防产品、摄录器材、电线电缆的销售；计算机软件开发（非研制）；计算机系统集成；建筑智能化工程施工（凭资质证经营）；企业管理咨询。
          </span>
          </div>
        </div>
      </div>
    </div>
     <Base></Base>
  </div>

</template>

<script>
  $(function() {

  });

  export default {
    data() {
      return {

      }
    },
    methods: {}




  }
</script>

<style>
  .btn-block {
    border-radius: 0px;
    height: 49px;
  }
.row{
    margin-left: 0px;
    margin-right: 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/gsjj.vue